'use client';
'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var Checkbox_parts = require('./Checkbox.parts.js');

/**
 * @component
 * @param {Object} props - 체크박스 컴포넌트 프로퍼티
 * @param {boolean} [props.checked=false] - 체크박스의 체크 상태
 * @param {(event: ChangeEvent<HTMLInputElement>) => void} [props.onChange] - 체크박스 상태 변경 시 호출되는 콜백 함수
 * @param {boolean} [props.disabled=false] - 체크박스 비활성화 여부
 * @param {boolean} [props.isError=false] - 체크박스 에러 상태 여부
 * @param {'box' | 'circle' | 'sub'} [props.type='box'] - 체크박스 타입
 * @param {string} [props.className] - 추가 CSS 클래스
 *
 * @example
 * // 기본 사용법
 * <Checkbox checked={isChecked} onChange={handleChange} />
 *
 * // 비활성화된 체크박스
 * <Checkbox disabled />
 *
 * // 에러 상태의 체크박스
 * <Checkbox isError />
 *
 * // 커스텀 스타일이 적용된 체크박스
 * <Checkbox className="custom-checkbox" />
 *
 * // 체크박스 상태 변경 핸들링
 * const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
 *   console.log('체크박스 상태:', e.target.checked);
 * };
 * <Checkbox onChange={handleChange} />
 */ const Checkbox = react.forwardRef((_a, ref)=>{
    var { checked = false, onChange, disabled = false, isError = false, type = 'box', className } = _a, rest = _tslib.__rest(_a, [
        "checked",
        "onChange",
        "disabled",
        "isError",
        "type",
        "className"
    ]);
    const [isChecked, setIsChecked] = react.useState(checked);
    const [isFocused, setIsFocused] = react.useState(false);
    react.useEffect(()=>{
        setIsChecked(checked);
    }, [
        checked
    ]);
    const handleChange = react.useCallback((e)=>{
        if (disabled) return;
        if (onChange) {
            onChange(e);
            setIsChecked(e.target.checked);
            if (!e.target.checked) setIsFocused(false);
        }
    }, [
        onChange,
        disabled
    ]);
    const handleFocus = ()=>{
        setIsFocused(true);
    };
    const handleBlur = ()=>{
        setIsFocused(false);
    };
    return jsxRuntime.jsxs("label", {
        "data-testid": "design-system-checkbox",
        className: "group flex size-fit",
        children: [
            jsxRuntime.jsx("input", Object.assign({
                ref: ref,
                className: "absolute h-0 w-0 opacity-0",
                type: "checkbox",
                checked: isChecked,
                onChange: handleChange,
                onFocus: handleFocus,
                onBlur: handleBlur,
                disabled: disabled
            }, rest)),
            jsxRuntime.jsx(Checkbox_parts.CheckboxButton, {
                checked: isChecked,
                disabled: disabled,
                isError: isError,
                isFocused: isFocused,
                type: type,
                className: className
            })
        ]
    });
});
Checkbox.displayName = 'Checkbox';

module.exports = Checkbox;
